export const TabRestaurantLite = [
  {
    id: 9,
    isVisible: true,
    title: 'Table management',
    type: 'dropdown',
    access: 'table_management',
    blocked: '/subscription-sales/restaurant-essentials/blocked',
    isGranted: true,
    subTab: [
      {
        id: 4,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/floor-plans',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Floor plans',
        type: 'link',
        access: 'table_management',
        isGranted: true,
      },
      {
        id: 5,
        isVisible: false,
        link: '/subscription-sales/restaurant-essentials/sections',
        blocked: '/subscription-sales/restaurant-essentials/blocked',
        title: 'Sections',
        type: 'link',
        access: 'table_management',
        isGranted: true,
      },
    ],
  },
];
